import { useQuery } from '@creditornot/converse-shared';
import { getAuthIdentity } from '../api';
export const useIdentity = () => {
    const { data } = useQuery({
        queryKey: ['authIdentity'],
        queryFn: getAuthIdentity,
        staleTime: Infinity,
    });
    return data?.identity;
};
//# sourceMappingURL=useIdentity.js.map